<template>
    <div id="idImportadorCotizacionesModal">
        <Button
            class="mt-2"
            :size="15" 
            color="#2da44e" 
            colorText="#ffffff" 
            tooltip="Importador Cotizaciones" 
            icon="fas fa-plus" 
            round 
            :width="30"
            @click.native="openModal('modal')"
            translate 
        />

        <ui-modal
            :title="`Importador Cotizaciones`"
            size="large" 
            ref="modal" 
            @close="closeModal('modal')"
        >
            <importador-cotizaciones-form-component
                :fncAfterSave="getQuotationImporters"
            />
        </ui-modal>
    </div>
</template>

<script>

import { mapActions } from 'vuex';
import UiModal from "keen-ui/src/UiModal";
import Button from '../../../../common/Button.vue';
import ImportadorCotizacionesFormComponent from '../../../../common/forms/ImportadorCotizacionesFormComponent.vue';
import { getQuotationImporters } from '../../../../../constants/lineas';

export default {
    data() {
        return {};
    },
    props: ["id"],

    components: { Button, UiModal, ImportadorCotizacionesFormComponent },

    created() {},

    mounted() {},

    methods: {

        ...mapActions(["ActionSetZindexModal"]),

        ...mapActions("lineas", [
            'actionSetDataDataTableQuotationImporter',
            'actionSetDataDataTableQuotationImporterLoading'
        ]),


        openModal(ref){
            this.ActionSetZindexModal(true);
            this.$refs[ref].open();
        },
        closeModal(ref){
            this.ActionSetZindexModal(false);
            this.$refs[ref].close();
        },

        async getQuotationImporters(){

            this.actionSetDataDataTableQuotationImporterLoading( true )  ;

            const { data } = await getQuotationImporters() ;

            this.actionSetDataDataTableQuotationImporter( data )

            this.actionSetDataDataTableQuotationImporterLoading( false )  ;

            this.closeModal('modal') ;
        },
    },

    computed: {},

    watch: {}
};
</script>

<style>

#idImportadorCotizacionesModal .ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
    width: 90% !important;
}

</style>

